import {i18n} from '../../plugins/i18n';
const state = {
  notificationVisibility: false,
  notificationType: 'info',
  notificationMessage: '',
  dialogVisibility: false,
  dialogTitle: '',
  dialogMessage: '',
  dialogSetResolve: null,
  spinner: false,
  searchPhrase: '',
  stateOptions: {},
  stateSeries: '',
  statePage: 0,
};

const getters = {
  notificationVisibility: (state) => state.notificationVisibility,
  notificationType: (state) => state.notificationType,
  notificationMessage: (state) => state.notificationMessage,
  dialogVisibility: (state) => state.dialogVisibility,
  dialogSetResolve: (state) => state.dialogSetResolve,
  dialogTitle: (state) => state.dialogTitle,
  dialogMessage: (state) => state.dialogMessage,
  spinner: (state) => state.spinner,
  searchPhrase: (state) => state.searchPhrase,
  stateOptions: (state) => state.stateOptions,
  stateSeries: (state) => state.stateSeries,
  statePage: (state) => state.statePage,

};

const mutations = {
  setNotification: (state, notificationData) => {
    state.notificationVisibility = notificationData.visibility;
    state.notificationType = notificationData.type;
    state.notificationMessage = notificationData.message;
  },
  setDialog: (state, dialogData)=>{
    state.dialogVisibility = dialogData.visibility;
    // Default: Warning
    state.dialogTitle = dialogData.title ? dialogData.title : i18n.t('common.warning');
    state.dialogMessage = dialogData.message;
    state.dialogSetResolve = dialogData.resolve;
  },
  setResolve: (state, resolveData)=>{
    state.dialogSetResolve(resolveData);
  },
  setSpinner: (state, spinner)=>{
    state.spinner = spinner;
  },
  setSearchPhrase: (state, searchPhrase)=>{
    state.searchPhrase = searchPhrase;
  },
  setStateOptions: (state, stateOptions)=>{
    state.stateOptions = stateOptions;
  },
  setStateSeries: (state, stateSeries)=>{
    state.stateSeries = stateSeries;
  },
  setStatePage: (state, statePage)=>{
    state.statePage = statePage;
  },


};

const actions = {
  askUser({commit}, data) {
    return new Promise((resolve, reject)=>{
      commit('setDialog', {...data, resolve});
    });
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
